import {
  ClientEntity,
  ClientOnboardingStatusType,
  OnboardingProcessEntity,
  OnboardingProcessStepNameType,
} from 'api/types/entity';

const stepsWithStatuses = [
  {
    step: OnboardingProcessStepNameType.ClientSigningDocuments,
    status: ClientOnboardingStatusType.SigningDocuments,
  },
  {
    step: OnboardingProcessStepNameType.ClientSigningContract,
    status: ClientOnboardingStatusType.SigningDocuments,
  },
  {
    step: OnboardingProcessStepNameType.ClientSigningQuestionnaire,
    status: ClientOnboardingStatusType.SigningQuestionnaire,
  },
];

export const useClientIsWaitingOnboardingStep = (
  process: OnboardingProcessEntity | undefined,
  ownerClient: ClientEntity | null
) => {
  const IsWaitingOnboardingStep = stepsWithStatuses.some(
    ({ status, step }) =>
      process?.currentStep.name === step &&
      ownerClient?.onboardingStatus !== status
  );

  return IsWaitingOnboardingStep;
};
